
import React from 'react';
import useConfirm from '../../hooks/useconfirm';
import { Modal } from 'react-bootstrap';
import './modal.scss';

const ConfirmDialog = () => {
    const { onConfirm, onCancel, confirmState } = useConfirm();
    return (
        <Modal show={confirmState.show} onHide={onCancel} centered
            className="confirm-modal" backdropClassName="confirm-backdrop"
            style={{ zIndex: 9999 }} enforceFocus={false}>
            <Modal.Body className="confirm-modal-body">
                <div className="confirm-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="11" stroke="#e74c3c" strokeWidth="2" />
                        <path d="M9 9l6 6M15 9l-6 6" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
                <div className="confirm-title">Are you sure?</div>
                <div className="confirm-message">
                    {confirmState?.text || 'This action cannot be undone.'}
                </div>
                <div className="confirm-actions">
                    <button className="confirm-cancel-btn" onClick={onCancel}>Cancel</button>
                    <button className="confirm-yes-btn" onClick={onConfirm}>Yes, Delete</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmDialog;
